






import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';
import('@/assets/header/' + process.env.VUE_APP_CLIENT + '/' + process.env.VUE_APP_THEME + '/style.scss').catch(e=>{
  import('@/assets/header/' + process.env.VUE_APP_CLIENT + '/style.scss')
});

import HeaderMixins from './mixins';

@Component
export default class Header extends mixins(Vue, HeaderMixins) {}
